module.exports = __webpack_public_path__ + "static/media/burger.a46b0074.svg";